// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__SfHj0","range":"MonthRangeSwitch_range__jwK6o","disabled":"MonthRangeSwitch_disabled__ZAcXN"};